<style lang="scss" scoped>
.input-field {
  margin: 0;
}

.input-field.compact {
  input {
    height: 36px;
  }
}

input {
  font-size: 0.8em;
  box-shadow: none !important;
}

input.borderless {
  border: 0;
  margin-bottom: 0;
  border: 0 !important;
}

.preloader-wrapper {
  top: 33%;
}

.input-icon-right {
  position: absolute;
  right: 20px;
}

.input-icon-right.tooltipped {
  top: 25%;
}
</style>

<template lang="pug">
.input-field(:class='{ compact: compact }')
  i.material-icons.prefix(v-if='icon') {{ icon }}
  input#location.autocomplete(
    type='text',
    :placeholder='placeholder',
    ref='location',
    v-model='location',
    autocomplete='off',
    :class='{ borderless: borderless }',
    @keyup.esc.exact='onCancel',
    @keyup='onInputChange'
  )

  .preloader-wrapper.xsmall.active.input-icon-right(
    v-if='isLoadingSuggestions'
  )
    .spinner-layer.spinner-green-only
      .circle-clipper.left
        .circle
      .gap-patch
        .circle
      .circle-clipper.right
        .circle
  span.tooltipped.input-icon-right(
    data-tooltip='Sorry, but it looks like we don&apos;t have anything for your city yet.',
    ref='negativeIndicator',
    v-show='!isLoadingSuggestions && !hasSuggestions'
  )
    i.material-icons sentiment_very_dissatisfied
</template>
<script>
/* eslint-disable no-undef */
import debounce from 'debounce'

export default {
  props: ['placeholder', 'icon', 'borderless', 'compact', 'initialLocation'],
  data() {
    return {
      isLoadingSuggestions: false,
      hasSuggestions: true,
      location: this.initialLocation,
      citiesAutocomplete: null,
      onInputChange: debounce(this.updateSuggestions, 500),
      cancel: false,
    }
  },
  mounted() {
    this.initializeInput()
    this.$M.Tooltip.init(this.$refs.negativeIndicator)
  },
  methods: {
    onCancel() {
      this.cancel = true
      this.$emit('onCancelAutocomplete')
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.location.focus()
        this.$refs.location.setSelectionRange(
          0,
          this.$refs.location.value.length
        )
      })
    },
    initializeInput() {
      this.citiesAutocomplete = this.$M.Autocomplete.init(this.$refs.location, {
        onAutocomplete: (val) => {
          this.$emit('onAutocomplete', val)
        },
      })
    },
    updateSuggestions() {
      if (this.cancel) {
        this.cancel = false
        return
      }

      this.isLoadingSuggestions = true
      // return this.$http
      //   .get(`${this.$config.API_URL}/config/places`, {
      //     params: {
      //       type: 'location',
      //       place: this.location
      //     }
      //   })
      //   .then(result => {
      //     const predictions = {}
      //     if (result) {
      //       this.hasSuggestions = result.data.data.length > 0
      //       for (let i = 0; i < result.data.data.length; i++) {
      //         predictions[result.data.data[i]] = null
      //       }
      //     }

      //     return predictions
      //   }).then(predictions => {
      //     this.citiesAutocomplete.updateData(predictions)
      //     this.citiesAutocomplete.open()
      //   }).finally(() => {
      //     this.isLoadingSuggestions = false
      //   })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/input-location-autocomplete.vue